import { z } from 'zod'

export const EntrySourceSchema = z.enum(['auto', 'manual'])
export type EntrySource = z.infer<typeof EntrySourceSchema>

export const TimeEntrySchema = z.object({
  id: z.string(),
  taskId: z.string(),
  employeeId: z.string(),
  startedAt: z.string(),
  stoppedAt: z.string().nullable(), // null = идёт сейчас
  source: EntrySourceSchema,
})
export type TimeEntry = z.infer<typeof TimeEntrySchema>

// Роллап по дереву задачи — производная (не сущность БД). total включает
// поддерево (учтён running-интервал до серверного «сейчас»), own — только узел.
export const RollupSchema = z.object({
  taskId: z.string(),
  totalSeconds: z.number(),
  ownSeconds: z.number(),
  running: z.boolean(),
})
export type Rollup = z.infer<typeof RollupSchema>

// «Что в работе сейчас» у вызывающего: идущий интервал + краткая проекция задачи
// (≤1 running на бэке). Питает таймер-бар каркаса и честный confirm-переключения.
export const RunningSchema = z.object({
  entryId: z.string(),
  startedAt: z.string(),
  taskId: z.string(),
  taskTitle: z.string(),
  boardId: z.string(),
  columnId: z.string(),
})
export type Running = z.infer<typeof RunningSchema>

// Разрез «по проекту» (счёт клиенту): сумма + строки по сотрудникам. department —
// готовое ИМЯ отдела (произвольная строка); опущен на бэке (omitempty) → null.
export const EmployeeGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  department: z.string().nullable(),
  seconds: z.number(),
})
export type EmployeeGroup = z.infer<typeof EmployeeGroupSchema>

export const ProjectReportSchema = z.object({
  projectId: z.string(),
  projectName: z.string(),
  totalSeconds: z.number(),
  byEmployee: z.array(EmployeeGroupSchema),
})
export type ProjectReport = z.infer<typeof ProjectReportSchema>

// Разрез «по человеку» (ЗП): сумма + строки по проектам.
export const ProjectGroupSchema = z.object({
  id: z.string(),
  name: z.string(),
  seconds: z.number(),
})
export type ProjectGroup = z.infer<typeof ProjectGroupSchema>

export const PersonReportSchema = z.object({
  employeeId: z.string(),
  employeeName: z.string(),
  totalSeconds: z.number(),
  byProject: z.array(ProjectGroupSchema),
})
export type PersonReport = z.infer<typeof PersonReportSchema>

// Разрез «команда»: строка на каждого сотрудника за период — в том числе на того,
// кто не списал ничего (нулевую строку отдаёт бэк, клиент её не выбрасывает).
// taskCount — по скольким задачам шло время, focusSeconds — сколько был в фокусе.
export const TeamMemberSchema = z.object({
  id: z.string(),
  name: z.string(),
  department: z.string().nullable(),
  seconds: z.number(),
  taskCount: z.number(),
  focusSeconds: z.number(),
})
export type TeamMember = z.infer<typeof TeamMemberSchema>

export const TeamReportSchema = z.object({
  totalSeconds: z.number(),
  totalFocusSeconds: z.number(),
  members: z.array(TeamMemberSchema),
})
export type TeamReport = z.infer<typeof TeamReportSchema>
